var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddmemberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.429 8.97755C13.5039 8.97755 15.186 7.29544 15.186 5.22046C15.186 3.14548 13.5039 1.46338 11.429 1.46338C9.35398 1.46338 7.67188 3.14548 7.67188 5.22046C7.67188 7.29544 9.35398 8.97755 11.429 8.97755Z",
    stroke: "#193243",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4287 10.4048C7.80778 10.4048 4.85254 12.1749 4.85254 14.3232V16.3102H17.9998V14.3232C17.9998 12.1749 15.0194 10.4048 11.4237 10.4048H11.4287Z",
    stroke: "#193243",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67432 8.18066V11.5646",
    stroke: "#193243",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.87012H4.39903",
    stroke: "#193243",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddmemberIcon);
export default __webpack_public_path__ + "static/media/addmember_icon.628eb3106ccdf39eb0d649835980ebfc.svg";
export { ForwardRef as ReactComponent };